import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { LoadingWrapper, StyledLottie, TextWrapper, TitleText } from './LoadingFinalStep.styles';

import LOADING_CONTRACT_LOTTIE from '@/assets/lotties/loading_contract.json';
import { useWelcomeModalStore } from '@/hooks/useWelcomeModal';
import { useMutateProfile, useProfile } from '@/store';

const MIN_LOADING_TIME = 3000;
const POLLING_INTERVAL = 1000;

export const LoadingFinalStep = () => {
  const { t } = useTranslation('StudentOnboardingPageTranslations');
  const { updateContract } = useMutateProfile();

  const { profile, refetch } = useProfile();
  const { finishOnboarding } = useMutateProfile();
  const [isLoading, setIsLoading] = useState(true);
  const [hasUpdatedContract, setHasUpdatedContract] = useState(false);
  const { openModal } = useWelcomeModalStore();

  const navigateTo = useNavigate();

  const handleContractUpdate = () => {
    if (!hasUpdatedContract) {
      setHasUpdatedContract(true);
      updateContract(undefined, {
        onSuccess: () => {
          finishOnboarding();
          refetch();
          openModal();
          navigateTo('/dashboard');
        }
      });
    }
  };
  useEffect(() => {
    const pollingInterval = setInterval(async () => {
      await refetch();
      if (profile?.contract?.contractFile) {
        clearInterval(pollingInterval);
      }
    }, POLLING_INTERVAL);

    const minLoadingTimer = setTimeout(() => {
      if (profile?.contract?.contractFile) {
        clearInterval(pollingInterval);
      }
      setIsLoading(false);
    }, MIN_LOADING_TIME);

    return () => {
      clearInterval(pollingInterval);
      clearTimeout(minLoadingTimer);
    };
  }, [profile?.contract?.contractFile, refetch]);

  useEffect(() => {
    const contractCorrect = profile?.contract?.contractFile;
    const notProd = !import.meta.env.PROD;
    const finishLoading = !isLoading && (contractCorrect || notProd);
    if (finishLoading) {
      handleContractUpdate();
    }
  }, [isLoading, profile?.contract?.contractFile]);

  return (
    <LoadingWrapper>
      <StyledLottie animationData={LOADING_CONTRACT_LOTTIE} autoPlay loop />
      <TextWrapper>
        <TitleText>{t('LOADING_APP_TITLE')}</TitleText>
        <span>{t('LOADING_APP_DESCRIPTION')}</span>
      </TextWrapper>
    </LoadingWrapper>
  );
};
